export default __webpack_public_path__ + "static/bg-25a220c84c9ed692c826cd94d411c9ae.svg";